import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { AssetDocumentZone, PendingDocumentMove } from "../../../../../api/ClientFileApi";
import { ClientFileQueryKey } from "../../../../../query/clientFileQueryKeys";
import { AssetDocumentsSection } from "../../../../components/asset-documents-section/AssetDocumentsSection";
import { useAssetInventoryDocuments } from "../../../../hooks/useAssetInventoryDocuments";
import { AssetExpensesFormValues } from "../../ExpensesView.types";

const SECTION = "clients.client.debtSettlement.assetInventory.expensesTab.proofs";

interface Props {
  clientId: string;
  formik: FormikProps<AssetExpensesFormValues>;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function ExpenseProofsSection({ clientId, formik, onAddMove, onCancelMove }: Props) {
  const { t } = useTranslation();
  const { documents, markRead, deleteDocument, isBusy } = useAssetInventoryDocuments(clientId, {
    queryKey: ClientFileQueryKey.AssetInventoryExpenseProofs,
    getDocuments: (api, params) => api.getAssetInventoryExpenseProofs(params),
    getDeleteDocument: (api) => api.deleteAssetInventoryExpenseProof.bind(api),
  });

  return (
    <AssetDocumentsSection
      clientId={clientId}
      formik={formik}
      fieldName="expenseProofs"
      zone={AssetDocumentZone.Expenses}
      title={t(`${SECTION}.title`)}
      uploadHint={t(`${SECTION}.uploadHint`)}
      documents={documents}
      onMarkRead={markRead}
      onDelete={deleteDocument}
      isBusy={isBusy}
      onAddMove={onAddMove}
      onCancelMove={onCancelMove}
    />
  );
}
